import { SessionState } from "../session.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";

export const setKeepAliveReducer = (
  state: SessionState,
  action: PayloadAction<boolean>,
) => {
  state.keepAlive = action.payload;
};
